import { render, staticRenderFns } from "./powerAdd.vue?vue&type=template&id=436ef2a4&scoped=true&"
import script from "./powerAdd.vue?vue&type=script&lang=js&"
export * from "./powerAdd.vue?vue&type=script&lang=js&"
import style0 from "./powerAdd.vue?vue&type=style&index=0&id=436ef2a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436ef2a4",
  null
  
)

component.options.__file = "powerAdd.vue"
export default component.exports